import Crud from '../components/Tip/Crud'
import Add from '../components/Tip/Add'
import Edit from '../components/Tip/Edit'

let routes = {
    path: '/tip',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/tip',
            component: Crud
        },
        {
            path: '/tip/add',
            component: Add
        },
        {
            path: '/tip/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/tip.js